import { RELATION_HAS_PART } from '@backstage/catalog-model';
import { EntityRelatedEntitiesGridItem } from './EntityRelatedEntitiesGridItem';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { EntityGridItemProps } from './EntityGridItemProps';

export const HasComponentsGridItem = (props: EntityGridItemProps) => {
  return (
    <EntityRelatedEntitiesGridItem
      {...props}
      relationFilter={{
        type: RELATION_HAS_PART,
        kind: 'Component',
      }}
      title={props.title ?? 'Has components'}
      orderedBy={['spec.type', 'metadata.name']}
      columns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'component' }),
        EntityTable.columns.createOwnerColumn(),
        EntityTable.columns.createSpecTypeColumn(),
        EntityTable.columns.createSpecLifecycleColumn(),
      ]}
      lgColumns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'component' }),
        EntityTable.columns.createOwnerColumn(),
        EntityTable.columns.createSpecTypeColumn(),
        EntityTable.columns.createSpecLifecycleColumn(),
        EntityTable.columns.createMetadataDescriptionColumn(),
      ]}
    />
  );
};
